var _a;
export var ScenarioOperator;
(function (ScenarioOperator) {
    ScenarioOperator[ScenarioOperator["ANY_OF"] = 1] = "ANY_OF";
    ScenarioOperator[ScenarioOperator["NONE_OF"] = 2] = "NONE_OF";
    ScenarioOperator[ScenarioOperator["ALL_OF"] = 3] = "ALL_OF";
    ScenarioOperator[ScenarioOperator["IS"] = 4] = "IS";
    ScenarioOperator[ScenarioOperator["IS_NOT"] = 5] = "IS_NOT";
    ScenarioOperator[ScenarioOperator["GREATER_THAN"] = 6] = "GREATER_THAN";
    ScenarioOperator[ScenarioOperator["LESS_THAN"] = 7] = "LESS_THAN";
    ScenarioOperator[ScenarioOperator["IS_SET"] = 8] = "IS_SET";
    ScenarioOperator[ScenarioOperator["NOT_SET"] = 9] = "NOT_SET";
    ScenarioOperator[ScenarioOperator["BETWEEN"] = 10] = "BETWEEN";
    ScenarioOperator[ScenarioOperator["IS_NOT_BETWEEN"] = 11] = "IS_NOT_BETWEEN";
})(ScenarioOperator || (ScenarioOperator = {}));
export var ScenarioConditionType;
(function (ScenarioConditionType) {
    // Common
    ScenarioConditionType[ScenarioConditionType["LOCALE"] = 10] = "LOCALE";
    ScenarioConditionType[ScenarioConditionType["LABEL"] = 20] = "LABEL";
    ScenarioConditionType[ScenarioConditionType["COMPANY"] = 30] = "COMPANY";
    ScenarioConditionType[ScenarioConditionType["QUEUE"] = 40] = "QUEUE";
    ScenarioConditionType[ScenarioConditionType["LINE"] = 50] = "LINE";
    //Kb 
    ScenarioConditionType[ScenarioConditionType["ARTICLE_TYPE"] = 110] = "ARTICLE_TYPE";
    ScenarioConditionType[ScenarioConditionType["ARTICLE_CATEGORY"] = 100] = "ARTICLE_CATEGORY";
    ScenarioConditionType[ScenarioConditionType["ARTICLE_VIEWS_COUNT"] = 120] = "ARTICLE_VIEWS_COUNT";
    ScenarioConditionType[ScenarioConditionType["ARTICLE_VOTES_COUNT"] = 130] = "ARTICLE_VOTES_COUNT";
    ScenarioConditionType[ScenarioConditionType["ARTICLE_LINKED_TICKETS_COUNT"] = 140] = "ARTICLE_LINKED_TICKETS_COUNT";
    // Tickets
    ScenarioConditionType[ScenarioConditionType["TICKET_PRIORITY"] = 200] = "TICKET_PRIORITY";
    ScenarioConditionType[ScenarioConditionType["TICKET_CHANNEL"] = 220] = "TICKET_CHANNEL";
    ScenarioConditionType[ScenarioConditionType["TICKET_MAILBOX"] = 210] = "TICKET_MAILBOX";
    ScenarioConditionType[ScenarioConditionType["TICKET_ASSIGNEE"] = 230] = "TICKET_ASSIGNEE";
    ScenarioConditionType[ScenarioConditionType["TICKET_REPLIES_COUNT"] = 240] = "TICKET_REPLIES_COUNT";
    ScenarioConditionType[ScenarioConditionType["TICKET_STATUS"] = 250] = "TICKET_STATUS";
    ScenarioConditionType[ScenarioConditionType["TICKET_SESSION_STATUS"] = 260] = "TICKET_SESSION_STATUS";
    // Team member
    ScenarioConditionType[ScenarioConditionType["AGENT_ROLE"] = 320] = "AGENT_ROLE";
    ScenarioConditionType[ScenarioConditionType["AGENT_LOCATION"] = 300] = "AGENT_LOCATION";
    ScenarioConditionType[ScenarioConditionType["AGENT_GROUP"] = 310] = "AGENT_GROUP";
    ScenarioConditionType[ScenarioConditionType["AGENT_ASSIGNED_CHANNEL"] = 330] = "AGENT_ASSIGNED_CHANNEL";
    ScenarioConditionType[ScenarioConditionType["AGENT_STATUS"] = 340] = "AGENT_STATUS";
    // Chat
    ScenarioConditionType[ScenarioConditionType["CHAT_WIDGET"] = 400] = "CHAT_WIDGET";
    // Calls
    ScenarioConditionType[ScenarioConditionType["PHONE_CALL_COUNTRY"] = 500] = "PHONE_CALL_COUNTRY";
    ScenarioConditionType[ScenarioConditionType["PHONE_CALL_TYPE"] = 510] = "PHONE_CALL_TYPE";
    //custom field 
    ScenarioConditionType[ScenarioConditionType["TICKET_BOOLEAN_CUSTOM_FIELD"] = 600] = "TICKET_BOOLEAN_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["TICKET_NUMBER_CUSTOM_FIELD"] = 610] = "TICKET_NUMBER_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["TICKET_SINGLE_SELECT_CUSTOM_FIELD"] = 620] = "TICKET_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["TICKET_TEXT_CUSTOM_FIELD"] = 630] = "TICKET_TEXT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["COMPANY_BOOLEAN_CUSTOM_FIELD"] = 700] = "COMPANY_BOOLEAN_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["COMPANY_NUMBER_CUSTOM_FIELD"] = 710] = "COMPANY_NUMBER_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["COMPANY_SINGLE_SELECT_CUSTOM_FIELD"] = 720] = "COMPANY_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["COMPANY_MULTI_SELECT_CUSTOM_FIELD"] = 740] = "COMPANY_MULTI_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["COMPANY_TEXT_CUSTOM_FIELD"] = 730] = "COMPANY_TEXT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["USER_BOOLEAN_CUSTOM_FIELD"] = 800] = "USER_BOOLEAN_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["USER_NUMBER_CUSTOM_FIELD"] = 810] = "USER_NUMBER_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["USER_SINGLE_SELECT_CUSTOM_FIELD"] = 820] = "USER_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["USER_MULTI_SELECT_CUSTOM_FIELD"] = 840] = "USER_MULTI_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["USER_TEXT_CUSTOM_FIELD"] = 830] = "USER_TEXT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["AGENT_BOOLEAN_CUSTOM_FIELD"] = 900] = "AGENT_BOOLEAN_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["AGENT_NUMBER_CUSTOM_FIELD"] = 910] = "AGENT_NUMBER_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["AGENT_SINGLE_SELECT_CUSTOM_FIELD"] = 920] = "AGENT_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["AGENT_TEXT_CUSTOM_FIELD"] = 930] = "AGENT_TEXT_CUSTOM_FIELD";
    ScenarioConditionType[ScenarioConditionType["AGENT_MULTI_SELECT_CUSTOM_FIELD"] = 940] = "AGENT_MULTI_SELECT_CUSTOM_FIELD";
})(ScenarioConditionType || (ScenarioConditionType = {}));
;
export var scenarioConditionToOperatorMap = (_a = {},
    _a[ScenarioConditionType.TICKET_PRIORITY] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.TICKET_STATUS] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.AGENT_ROLE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.LABEL] = [
        ScenarioOperator.ANY_OF,
        ScenarioOperator.ALL_OF,
        ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET,
        ScenarioOperator.NOT_SET
    ],
    _a[ScenarioConditionType.AGENT_LOCATION] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.TICKET_ASSIGNEE] = [
        ScenarioOperator.ANY_OF,
        ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET,
        ScenarioOperator.NOT_SET
    ],
    _a[ScenarioConditionType.TICKET_REPLIES_COUNT] = [ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN],
    _a[ScenarioConditionType.ARTICLE_TYPE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.ARTICLE_LINKED_TICKETS_COUNT] = [ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN],
    _a[ScenarioConditionType.ARTICLE_VIEWS_COUNT] = [ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN],
    _a[ScenarioConditionType.ARTICLE_VOTES_COUNT] = [ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN],
    _a[ScenarioConditionType.ARTICLE_CATEGORY] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.AGENT_GROUP] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.AGENT_ASSIGNED_CHANNEL] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.AGENT_STATUS] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.LOCALE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.CHAT_WIDGET] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.COMPANY] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.PHONE_CALL_COUNTRY] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.QUEUE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.LINE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.TICKET_CHANNEL] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.TICKET_MAILBOX] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a[ScenarioConditionType.TICKET_SESSION_STATUS] = [ScenarioOperator.IS],
    _a[ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET,
        ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN, ScenarioOperator.BETWEEN, ScenarioOperator.IS_NOT_BETWEEN],
    _a[ScenarioConditionType.TICKET_BOOLEAN_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.COMPANY_NUMBER_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET,
        ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN, ScenarioOperator.BETWEEN, ScenarioOperator.IS_NOT_BETWEEN],
    _a[ScenarioConditionType.COMPANY_BOOLEAN_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.USER_NUMBER_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET,
        ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN, ScenarioOperator.BETWEEN, ScenarioOperator.IS_NOT_BETWEEN],
    _a[ScenarioConditionType.USER_BOOLEAN_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.AGENT_NUMBER_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET,
        ScenarioOperator.GREATER_THAN, ScenarioOperator.LESS_THAN, ScenarioOperator.BETWEEN, ScenarioOperator.IS_NOT_BETWEEN],
    _a[ScenarioConditionType.AGENT_BOOLEAN_CUSTOM_FIELD] = [ScenarioOperator.IS, ScenarioOperator.IS_NOT, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.COMPANY_SINGLE_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.USER_SINGLE_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.AGENT_SINGLE_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.COMPANY_MULTI_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.USER_MULTI_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.AGENT_MULTI_SELECT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF,
        ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.TICKET_TEXT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.COMPANY_TEXT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.USER_TEXT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.AGENT_TEXT_CUSTOM_FIELD] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF, ScenarioOperator.ALL_OF, ScenarioOperator.IS_SET, ScenarioOperator.NOT_SET],
    _a[ScenarioConditionType.PHONE_CALL_TYPE] = [ScenarioOperator.ANY_OF, ScenarioOperator.NONE_OF],
    _a);
export var spotterEmptyConditionMap = function (conditionType) {
    var _a;
    var map = (_a = {},
        _a[ScenarioConditionType.LOCALE] = {
            conditionType: ScenarioConditionType.LOCALE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.LOCALE][0],
            locales: [],
        },
        _a[ScenarioConditionType.LABEL] = {
            conditionType: ScenarioConditionType.LABEL,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.LABEL][0],
            labelIds: [],
        },
        _a[ScenarioConditionType.ARTICLE_TYPE] = {
            conditionType: ScenarioConditionType.ARTICLE_TYPE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.ARTICLE_TYPE][0],
            articleTypes: [],
        },
        _a[ScenarioConditionType.TICKET_REPLIES_COUNT] = {
            conditionType: ScenarioConditionType.TICKET_REPLIES_COUNT,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_REPLIES_COUNT][0],
            count: null,
        },
        _a[ScenarioConditionType.ARTICLE_LINKED_TICKETS_COUNT] = {
            conditionType: ScenarioConditionType.ARTICLE_LINKED_TICKETS_COUNT,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.ARTICLE_LINKED_TICKETS_COUNT][0],
            count: null,
        },
        _a[ScenarioConditionType.ARTICLE_VIEWS_COUNT] = {
            conditionType: ScenarioConditionType.ARTICLE_VIEWS_COUNT,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.ARTICLE_VIEWS_COUNT][0],
            count: null,
        },
        _a[ScenarioConditionType.ARTICLE_VOTES_COUNT] = {
            conditionType: ScenarioConditionType.ARTICLE_VOTES_COUNT,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.ARTICLE_VOTES_COUNT][0],
            count: null,
        },
        _a[ScenarioConditionType.COMPANY] = {
            conditionType: ScenarioConditionType.COMPANY,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY][0],
            companyIds: [],
        },
        _a[ScenarioConditionType.QUEUE] = {
            conditionType: ScenarioConditionType.QUEUE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.QUEUE][0],
            queueIds: [],
        },
        _a[ScenarioConditionType.LINE] = {
            conditionType: ScenarioConditionType.LINE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.LINE][0],
            lineIds: [],
        },
        _a[ScenarioConditionType.CHAT_WIDGET] = {
            conditionType: ScenarioConditionType.CHAT_WIDGET,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.CHAT_WIDGET][0],
            widgetIds: [],
        },
        _a[ScenarioConditionType.TICKET_PRIORITY] = {
            conditionType: ScenarioConditionType.TICKET_PRIORITY,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_PRIORITY][0],
            ticketPriorities: [],
        },
        _a[ScenarioConditionType.TICKET_ASSIGNEE] = {
            conditionType: ScenarioConditionType.TICKET_ASSIGNEE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_ASSIGNEE][0],
            assignedUserIds: [],
            assignedGroupIds: [],
        },
        _a[ScenarioConditionType.TICKET_STATUS] = {
            conditionType: ScenarioConditionType.TICKET_STATUS,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_STATUS][0],
            ticketStatuses: [],
        },
        _a[ScenarioConditionType.TICKET_SESSION_STATUS] = {
            conditionType: ScenarioConditionType.TICKET_SESSION_STATUS,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_SESSION_STATUS][0],
            ticketSessionStatus: null,
        },
        _a[ScenarioConditionType.AGENT_ROLE] = {
            conditionType: ScenarioConditionType.AGENT_ROLE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_ROLE][0],
            roleIds: [],
        },
        _a[ScenarioConditionType.AGENT_LOCATION] = {
            conditionType: ScenarioConditionType.AGENT_LOCATION,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_LOCATION][0],
            locationIds: [],
        },
        _a[ScenarioConditionType.AGENT_GROUP] = {
            conditionType: ScenarioConditionType.AGENT_GROUP,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_GROUP][0],
            groupIds: []
        },
        _a[ScenarioConditionType.AGENT_ASSIGNED_CHANNEL] = {
            conditionType: ScenarioConditionType.AGENT_ASSIGNED_CHANNEL,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_ASSIGNED_CHANNEL][0],
            activityTypes: [],
        },
        _a[ScenarioConditionType.AGENT_STATUS] = {
            conditionType: ScenarioConditionType.AGENT_STATUS,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_STATUS][0],
            agentStatuses: [],
            callCenterAgentStatuses: [],
            agentCustomStatusIds: [],
        },
        _a[ScenarioConditionType.PHONE_CALL_COUNTRY] = {
            conditionType: ScenarioConditionType.PHONE_CALL_COUNTRY,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.PHONE_CALL_COUNTRY][0],
            countryCodes: [],
        },
        _a[ScenarioConditionType.TICKET_CHANNEL] = {
            conditionType: ScenarioConditionType.TICKET_CHANNEL,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_CHANNEL][0],
            channels: [],
        },
        _a[ScenarioConditionType.TICKET_MAILBOX] = {
            conditionType: ScenarioConditionType.TICKET_MAILBOX,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_MAILBOX][0],
            mailboxIds: [],
        },
        _a[ScenarioConditionType.ARTICLE_CATEGORY] = {
            conditionType: ScenarioConditionType.ARTICLE_CATEGORY,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.ARTICLE_CATEGORY][0],
            categoryIds: [],
        },
        _a[ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD][0],
            from: null,
            to: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.TICKET_BOOLEAN_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.TICKET_BOOLEAN_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_BOOLEAN_CUSTOM_FIELD][0],
            boolValue: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.COMPANY_NUMBER_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.COMPANY_NUMBER_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY_NUMBER_CUSTOM_FIELD][0],
            from: null,
            to: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.COMPANY_BOOLEAN_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.COMPANY_BOOLEAN_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY_BOOLEAN_CUSTOM_FIELD][0],
            boolValue: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.USER_NUMBER_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.USER_NUMBER_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.USER_NUMBER_CUSTOM_FIELD][0],
            from: null,
            to: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.USER_BOOLEAN_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.USER_BOOLEAN_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.USER_BOOLEAN_CUSTOM_FIELD][0],
            boolValue: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.AGENT_NUMBER_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.AGENT_NUMBER_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_NUMBER_CUSTOM_FIELD][0],
            from: null,
            to: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.AGENT_BOOLEAN_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.AGENT_BOOLEAN_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_BOOLEAN_CUSTOM_FIELD][0],
            boolValue: null,
            customFieldId: null
        },
        _a[ScenarioConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.COMPANY_SINGLE_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.COMPANY_SINGLE_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY_SINGLE_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.USER_SINGLE_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.USER_SINGLE_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.USER_SINGLE_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.AGENT_SINGLE_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.AGENT_SINGLE_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_SINGLE_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.COMPANY_MULTI_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.COMPANY_MULTI_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY_MULTI_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.USER_MULTI_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.USER_MULTI_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.USER_MULTI_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.AGENT_MULTI_SELECT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.AGENT_MULTI_SELECT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_MULTI_SELECT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: ''
        },
        _a[ScenarioConditionType.TICKET_TEXT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.TICKET_TEXT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.TICKET_TEXT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: null
        },
        _a[ScenarioConditionType.COMPANY_TEXT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.COMPANY_TEXT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.COMPANY_TEXT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: null
        },
        _a[ScenarioConditionType.AGENT_TEXT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.AGENT_TEXT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.AGENT_TEXT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: null
        },
        _a[ScenarioConditionType.USER_TEXT_CUSTOM_FIELD] = {
            conditionType: ScenarioConditionType.USER_TEXT_CUSTOM_FIELD,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.USER_TEXT_CUSTOM_FIELD][0],
            values: [],
            customFieldId: null
        },
        _a[ScenarioConditionType.PHONE_CALL_TYPE] = {
            conditionType: ScenarioConditionType.PHONE_CALL_TYPE,
            operator: scenarioConditionToOperatorMap[ScenarioConditionType.PHONE_CALL_TYPE][0],
            callTypes: []
        },
        _a);
    return map[conditionType];
};
//# sourceMappingURL=conditions.js.map